
import { LockDec, ValidateDec } from '@/decorators'
import { Component, Prop, Vue } from 'vue-facing-decorator'

@Component({})
export default class extends Vue {
  /** 当前要改的 SKU 行 */
  @Prop()
  modelValue: any

  /** popover 给的关闭方法，改完要主动收起 */
  @Prop()
  hideEvent: any

  postData = {
    /** 1 增加、0 减少 */
    type: 1,
    stock: '',
  }

  submitLoading = false;

  get skuTitle() {
    return this.modelValue?.name ? `（${this.modelValue.name}）` : '';
  }

  /** 规则和后端 GoodsSkuStockOperatDto 对齐：正整数，增减由 type 决定 */
  validateStock(v) {
    if (v === '' || v === null || v === undefined) throw '请输入数量';
    if (!/^\d+$/.test(String(v))) throw '数量必须为整数';
    if (Number(v) < 1) throw '数量必须大于 0';
    if (Number(v) > 9999999) throw '数量超出范围';
  }

  @LockDec('submitLoading')
  @ValidateDec('form')
  async confirm() {
    /** 这里传的是增减量，不是改完之后的库存，后端自己原子加减 */
    let data = await this.$postNotify('/manager/goods/stock-operat', {
      id: this.modelValue.id,
      type: this.postData.type,
      stock: Number(this.postData.stock),
    })
    /** 改完直接收起整个 popover，不用再看列表 */
    if (this.hideEvent) this.hideEvent();
    /** 把后端算出来的最新库存带出去，调用方要拿它回写行上的数字 */
    this.$emit('success', data);
  }

  /** 取消只是退回 SKU 列表，不关 popover */
  cancel() {
    this.$emit('back');
  }
}
